import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-truck",
  "use": "icon-truck-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-truck\">\r\n<path d=\"M45.4,98.9c0,6.4-5.2,11.6-11.6,11.6s-11.6-5.2-11.6-11.6c0-6.4,5.2-11.6,11.6-11.6C40.2,87.3,45.4,92.5,45.4,98.9\r\n\tC45.4,98.9,45.4,98.9,45.4,98.9z M110.5,98.9c0,6.4-5.2,11.6-11.6,11.6c-6.4,0-11.6-5.2-11.6-11.6c0-6.4,5.2-11.6,11.6-11.6\r\n\tC105.3,87.3,110.5,92.5,110.5,98.9C110.5,98.9,110.5,98.9,110.5,98.9z M120.9,59.3l-10.4-18.5c-2.1-2.6-3.6-4.7-7-4.7H87.3v-14\r\n\tc0-2.6-2.1-4.6-4.7-4.7H8.1c-2.6,0-4.6,2.1-4.7,4.7v69.8c0,2.6,2.1,4.6,4.7,4.7h9.3c1.2-9,9.5-15.3,18.6-14.1\r\n\tc7.3,1,13.1,6.8,14.1,14.1h32.5c1.2-9,9.6-15.3,18.6-14.1c7.3,1,13.1,6.8,14.1,14.1h4.6c2.6,0,4.6-2.1,4.7-4.7V68.7\r\n\tC124.5,64.2,120.9,59.3,120.9,59.3L120.9,59.3z M91.9,68.7V45.4h11.4c0.8,0,1.8,1.1,1.8,1.1l9.8,18.2c0.9,1.1,1.6,2.5,1.8,4\r\n\tL91.9,68.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/truck.svg
// module id = 3Kjf
// module chunks = 171